// extracted by mini-css-extract-plugin
module.exports = {"container":"pickup-artist_container__59VFo","featuredList":"pickup-artist_featuredList__3E4G4","col":"pickup-artist_col__zZD5q","avatar":"pickup-artist_avatar__FNUPK"};